import React from 'react'
import cn from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'

const Group = styled.div`
  display: flex;
  gap: ${rem(4)};

  &.align-wrap {
    flex-wrap: wrap;
  }

  &.align-wrap-center {
    flex-wrap: wrap;
    justify-content: center;
  }

  &:empty {
    display: none;
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  align?: 'wrap' | 'wrap-center';
}

const LabelGroup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className, align = 'wrap', ...rest } = props

  return <Group {...rest} ref={ref} className={cn(className, `align-${align}`)} />
})

LabelGroup.displayName = 'LabelGroup'

export default LabelGroup
